import { IColumn } from "@fluentui/react";

export const columns: IColumn[] = [
    {
        key: "sessionId",
        name: "sessionId",
        fieldName: "sessionId",
        minWidth: 280,
        maxWidth: 320,
        isResizable: true,
    },
    {
        key: "workflowId",
        name: "workflowId",
        fieldName: "workflowId",
        minWidth: 280,
        maxWidth: 320,
        isResizable: true,
    },
    {
        key: "startTimestamp",
        name: "startTimestamp",
        fieldName: "startTimestamp",
        minWidth: 160,
        maxWidth: 180,
        isResizable: true,
    },
    {
        key: "runDuration",
        name: "runDuration (s)",
        fieldName: "runDuration",
        minWidth: 100,
        maxWidth: 120,
        isResizable: true,
    },
    {
        key: "status",
        name: "status",
        fieldName: "status",
        minWidth: 80,
        isResizable: true,
    },
    {
        key: "topic",
        name: "topic",
        fieldName: "topic",
        minWidth: 200,
        maxWidth: 400,
        isResizable: true,
    },
    {
        key: "reviewScores",
        name: "reviewScores",
        fieldName: "reviewScores",
        minWidth: 120,
        maxWidth: 200,
        isResizable: true,
    },
    {
        key: "endTimestamp",
        name: "endTimestamp",
        fieldName: "endTimestamp",
        minWidth: 160,
        maxWidth: 180,
        isResizable: true,
    },
    // {
    //     key: "industry",
    //     name: "industry",
    //     fieldName: "industry",
    //     minWidth: 100,
    //     isResizable: true,
    // },
    // {
    //     key: "purpose",
    //     name: "purpose",
    //     fieldName: "purpose",
    //     minWidth: 100,
    //     isResizable: true,
    // },
    {
        key: "style",
        name: "style",
        fieldName: "style",
        minWidth: 80,
        isResizable: true,
    },
    {
        key: "version",
        name: "version",
        fieldName: "version",
        minWidth: 80,
        maxWidth: 100,
        isResizable: true,
    },
    {
        key: "toggleSettings",
        name: "toggleSettings",
        fieldName: "toggleSettings",
        minWidth: 150,
        maxWidth: 200,
        isResizable: true,
    },
    // {
    //     key: "renderContent",
    //     name: "renderContent",
    //     fieldName: "renderContent",
    //     minWidth: 50,
    //     isResizable: true,
    // },
    // {
    //     key: "outlineGenerationOptions",
    //     name: "outlineGenerationOptions",
    //     fieldName: "outlineGenerationOptions",
    //     minWidth: 200,
    //     isResizable: true,
    // },
    // {
    //     key: "themeGenerationOptions",
    //     name: "themeGenerationOptions",
    //     fieldName: "themeGenerationOptions",
    //     minWidth: 200,
    //     isResizable: true,
    // },
    {
        key: "handle",
        name: "Handle",
        fieldName: "handle",
        minWidth: 100,
        maxWidth: 120,
        isResizable: true,
    },
];
